module.exports = __webpack_public_path__ + "img/homepage-support-bg.03c480df.png";